import { forwardRef } from '@chakra-ui/react';

import Input, { InputProps } from './';

export type AmountInputProps = InputProps;

export const AmountInput = forwardRef<InputProps, 'input'>(
  ({ onKeyDown, ...props }, ref) => {
    return (
      <Input
        inputMode="numeric"
        onKeyDown={(e) => {
          // Make sure we can't use these characters in the input field
          if (['E', 'e', '-', '+'].includes(e.key)) {
            e.preventDefault();
          }
          onKeyDown?.(e);
        }}
        ref={ref}
        rightIcon="euro"
        step={0.01}
        type="number"
        {...props}
      />
    );
  },
);
